import { useState } from 'react';
import { useClientLayoutEffect } from './useClientLayoutEffect.js';

function useMinContentHeight(ref, disabled = false) {
  const [minHeight, setMinHeight] = useState(void 0);
  useClientLayoutEffect(() => {
    if (disabled) return;
    const element = ref.current;
    if (!element) return;
    let resizeObserver = null;
    let mutationObserver = null;
    let clone = null;
    const measureMinHeight = () => {
      clone = element.cloneNode(true);
      Object.assign(clone.style, {
        position: "absolute",
        visibility: "hidden",
        height: "auto",
        minHeight: "min-content",
        maxHeight: "none",
        overflow: "visible",
        width: `${element.offsetWidth}px`,
        animaton: "unset"
      });
      document.body.appendChild(clone);
      const measuredHeight = Math.round(clone.getBoundingClientRect().height);
      document.body.removeChild(clone);
      clone = null;
      setMinHeight(measuredHeight);
    };
    measureMinHeight();
    resizeObserver = new ResizeObserver(measureMinHeight);
    mutationObserver = new MutationObserver(measureMinHeight);
    resizeObserver.observe(element);
    mutationObserver.observe(element, {
      attributes: true,
      childList: true,
      subtree: true
    });
    return () => {
      resizeObserver.unobserve(element);
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      if (clone?.parentElement) {
        clone.parentElement.removeChild(clone);
      }
    };
  }, [
    ref,
    disabled
  ]);
  return minHeight;
}

export { useMinContentHeight as default };
//# sourceMappingURL=useMinContentHeight.js.map
